import React from 'react';
import { Maximize2, Minimize2, ArrowLeft, ArrowRight } from 'lucide-react';
import { usePresentationMode } from '../context/PresentationModeContext';
import { useLanguage } from '../context/LanguageContext';

/**
 * PresentationModeButton - Toggle button for Board Presentation Mode
 * Shows in the header, allows entering/exiting fullscreen presentation mode
 */
const PresentationModeButton = () => {
  const { isPresentationMode, togglePresentationMode } = usePresentationMode();
  const { language } = useLanguage();

  return (
    <div className="flex items-center gap-2">
      {isPresentationMode && (
        <div className="flex items-center gap-1 text-xs text-white/60 bg-white/10 px-2 py-1 rounded">
          <ArrowLeft className="w-3 h-3" />
          <ArrowRight className="w-3 h-3" />
          <span className="ml-1">{language === 'pt' ? 'Navegar' : 'Navigate'}</span>
        </div>
      )}
      <button
        onClick={togglePresentationMode}
        data-testid="presentation-mode-toggle"
        className={`
          flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
          transition-all duration-200 ease-in-out
          ${isPresentationMode 
            ? 'bg-amber-500 text-white shadow-lg shadow-amber-500/30 hover:bg-amber-600' 
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-800'
          }
        `}
        title={isPresentationMode 
          ? (language === 'pt' ? 'Sair do Modo Apresentação (Esc)' : 'Exit Presentation Mode (Esc)')
          : (language === 'pt' ? 'Modo Apresentação (F11)' : 'Presentation Mode (F11)')
        }
      >
        {isPresentationMode ? (
          <>
            <Minimize2 className="w-4 h-4" />
            <span className="hidden sm:inline">
              {language === 'pt' ? 'Sair' : 'Exit'}
            </span>
          </>
        ) : (
          <>
            <Maximize2 className="w-4 h-4" />
            <span className="hidden sm:inline">
              {language === 'pt' ? 'Board' : 'Board'}
            </span>
          </>
        )}
      </button>
    </div>
  );
};

export default PresentationModeButton;
